export class JobProgressStepGroupMessageRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groupEmail",
            "baseName": "groupEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalMessages",
            "baseName": "totalMessages",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "restoredMessages",
            "baseName": "restoredMessages",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "consoleUrl",
            "baseName": "consoleUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepGroupMessageRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
